import React from 'react'
import { ClockProps } from './Clock.types'
import styles from './Clock.module.scss'
import cl from 'classnames'
import { H1, Text1 } from 'components/shared'
import { useTime } from './Clock.utils'

const ClockComponent = (props: ClockProps) => {
  const {
    className,
    style
  } = props

  const time = useTime()

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
      title={time.format('hh:mm A, DD/MM/YYYY')}
    >
      <H1 bold>{time.format('hh:mm')}</H1>
      <Text1 className={styles.dayPart}>{time.format('A')}</Text1>
    </div>
  )
}

const Clock = ClockComponent
export { Clock }
